/**
 * Object describing what state a request is in.
 */
export enum LoadingState {
    INITIAL = 'initial',
    LOADING = 'loading',
    SUCCESS = 'success',
    FAILURE = 'failure',
}
